import request from './axios'

// 注册
export const register = (data) => request({
  url: '/user/register',
  method: 'post',
  data: data
})

// 登录
export const login = (data) => request({
  url: '/user/login',
  method: 'post',
  data: data
})

// 忘记账号
export const forgetUsername = (data) => request({
  url: '/user/forgetUsername',
  method: 'post',
  data: data
})

// 忘记密码
export const forgetPassword = (data) => request({
  url: '/user/requestResetPassword',
  method: 'post',
  data: data
})

// 重置密码
export const resetPassword = (data) => request({
  url: '/user/resetPassword',
  method: 'post',
  data: data
})

// 获取用户信息
export const getUserInfo = (data) => request({
  url: '/user/info',
  method: 'post',
  data: data
})

// 退出登录
export const logout = (data) => request({
  url: '/user/logout',
  method: 'post',
  data: data
})

// 获取指定等级+所属id的商品分类列表
export const categoryList = (data) => request({
  url: '/shop/category/list',
  method: 'post',
  data: data
})

// 获取商品列表
export const commodityList = (data) => request({
  url: '/shop/commodity/list',
  method: 'post',
  data: data
})

// 获取商品列表
export const commodityGetInfo = (data) => request({
  url: '/shop/commodity/getInfo',
  method: 'post',
  data: data
})

// 文章列表
export const articleList = (data) => request({
  url: '/article/list',
  method: 'post',
  data: data
})

// 文章详情
export const articleDetails = (data) => request({
  url: '/article/get',
  method: 'post',
  data: data
})

// 添加购物车商品
export const addCartItems = (data) => request({
  url: '/shop/cart/addCartItems',
  method: 'post',
  data: data
})

// 修改购物车中商品的数量
export const setCartItemCount = (data) => request({
  url: '/shop/cart/setCartItemCount',
  method: 'post',
  data: data
})

// 获取购物车列表
export const getCartItems = (data) => request({
  url: '/shop/cart/getCartItems',
  method: 'post',
  data: data
})

// 删除购物车
export const deleteCartItems = (data) => request({
  url: '/shop/cart/deleteCartItem',
  method: 'post',
  data: data
})

// 更新收件地址
export const updateAddress = (data) => request({
  url: '/user/updateAddress',
  method: 'post',
  data: data
})

// 获取订单数据 普通用户
export const orderList = (data) => request({
  url: '/shop/order/list',
  method: 'post',
  data: data
})

// 点击结算  => 新建订单
export const newOrder = (data) => request({
  url: '/shop/order/newOrder',
  method: 'post',
  data: data
})

// 更新订单状态  => 查询待支付订单
export const orderUpdateStatus = (data) => request({
  url: '/shop/order/updateStatus',
  method: 'post',
  data: data
})

// 支付订单
export const payOrder = (data) => request({
  url: '/shop/order/payOrder',
  method: 'post',
  data: data
})

// 取消订单
export const cancelOrder = (data) => request({
  url: '/shop/order/cancel',
  method: 'post',
  data: data
})

// 支付后 查询订单状态
export const queryOrder = (data) => request({
  url: '/shop/order/queryOrder',
  method: 'post',
  data: data
})



// WEBPACK FOOTER //
// ./src/api/api.js